<template>
  <div>
    <div class="content">
      <div class="content-add-detail">
        <el-form
          :model="queryParams"
          :rules="queryParamsRules"
          ref="queryParamsRefs"
          :class="!isUpdateInformation ? 'details-line-height' : ''"
          :label-width="!isUpdateInformation? '' : '85px'"
          class="demo-form-inline"
        >
          <div class="add-basic-information">
            <div class="add-title">
              <span class="bold"></span>
              <span class="basic">基本信息</span>
            </div>
            <div class="add-content">
              <div class="save" v-if="+$route.query.approvalState !==1">
                <el-button type v-if="!isUpdateInformation" @click="onUpdateInformation">修改</el-button>
                <el-button v-if="isUpdateInformation" @click="onUpdateCancel">取消</el-button>
                <el-button type="primary" v-if="isUpdateInformation" @click="onSaveInformation">保存</el-button>
              </div>
              <el-row>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="品类：">
                      <span v-if="!isUpdateInformation">{{queryParams.pcName}}</span>
                      <!-- <el-cascader
                        v-if="isUpdateInformation"
                        v-model="queryParams.pcId"
                        :options="proClassList"
                        @change="handleChange"
                      ></el-cascader>-->
                      <el-input
                        v-if="isUpdateInformation"
                        :disabled="true"
                        v-model="queryParams.pcName"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="品牌：" prop="brandId">
                      <span v-if="!isUpdateInformation">{{queryParams.brandName}}</span>
                      <el-select
                        v-if="isUpdateInformation"
                        v-model="queryParams.brandId"
                        @change="onChangeBrand(queryParams.brandId)"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(item,index) in brandList"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="系列：" prop="brandSid">
                      <span v-if="!isUpdateInformation">{{queryParams.seriesName}}</span>
                      <el-select
                        v-if="isUpdateInformation"
                        v-model="queryParams.brandSid"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(item,index) in seriesList"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="产品名称：" prop="proName">
                      <span v-if="!isUpdateInformation">{{queryParams.proName}}</span>
                      <el-input v-if="isUpdateInformation" v-model="queryParams.proName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="型号：" prop="proModel">
                      <span v-if="!isUpdateInformation">{{queryParams.proModel}}</span>
                      <el-input v-if="isUpdateInformation" v-model="queryParams.proModel"></el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="订货号：">
                      <span v-if="!isUpdateInformation">{{queryParams.proOrdernum}}</span>
                      <el-input v-if="isUpdateInformation" v-model="queryParams.proOrdernum"></el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="属地：">
                      <span v-if="!isUpdateInformation">{{queryParams.proTerritory}}</span>
                      <el-select
                        v-if="isUpdateInformation"
                        v-model="queryParams.proTerritory"
                        clearable
                        placeholder="全部"
                      >
                        <el-option
                          v-for="item in productTerritoryList"
                          :key="item.productTerritory"
                          :label="item.title"
                          :value="item.productTerritory"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="是否停产：">
                      <span v-if="!isUpdateInformation">{{queryParams.isStop===0?'是':'否'}}</span>
                      <el-radio-group v-if="isUpdateInformation" v-model="queryParams.isStop">
                        <el-radio :label="0">是</el-radio>
                        <el-radio :label="1">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-col>
                <!-- <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="质保期：">
                      <el-col :span="18">
                        <el-input-number
                          :controls="false"
                          :precision="0"
                          :min="1"
                          v-if="isUpdateInformation"
                          v-model.number="queryParams.proWarranty"
                        ></el-input-number>
                      </el-col>
                      <el-col :span="6" style="text-align:left">
                        <span v-if="!isUpdateInformation">{{queryParams.proWarranty}}</span>
                        <span>天</span>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-col>-->
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="最小单位：" prop="proUnit">
                      <span v-if="!isUpdateInformation">{{queryParams.proUnit}}</span>
                      <el-select
                        v-if="isUpdateInformation"
                        v-model="queryParams.proUnit"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(item,index) in unitList"
                          :key="index"
                          :label="item.attrName"
                          :value="item.attrName"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="24" v-if="!isUpdateInformation">
                    <el-form-item label="出货单位：" prop="proOutunit">
                      <span>
                        <span v-if="queryParams.proOutunit!=='套装出售'">{{queryParams.proOutunit}}</span>
                        <span
                          v-if="queryParams.proOutunit==='套装出售'"
                        >{{queryParams.proOutunit}} {{queryParams.proOutunitCount}}{{queryParams.proUnit+"/"}}{{queryParams.proOutunitUnit}}</span>
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24" v-if="isUpdateInformation">
                    <el-col :span="10">
                      <el-form-item label="出货单位：" prop="proOutunit">
                        <el-select
                          v-model="queryParams.proOutunit"
                          placeholder="请选择"
                          @change="onChangeOutunit"
                        >
                          <el-option label="单件出售" value="单件出售"></el-option>
                          <el-option label="套装出售" value="套装出售"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="14" v-if="queryParams.proOutunit==='套装出售'&&queryParams.proUnit">
                      <el-row>
                        <el-col :span="9">
                          <el-input-number
                            type="number"
                            :min="1"
                            style="width:100%;margin-left:2px;margin-top:1px;"
                            :controls="false"
                            :precision="0"
                            v-model.number="queryParams.proOutunitCount"
                            placeholder="数量"
                          ></el-input-number>
                        </el-col>
                        <el-col
                          :span="6"
                          style="font-size:14px;text-align:center;margin-top:3px;"
                        >{{queryParams.proUnit}}/</el-col>
                        <el-col :span="8">
                          <el-input placeholder="单位" v-model.trim="queryParams.proOutunitUnit"></el-input>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="产品面价：" prop="proPrice">
                      <span
                        v-if="!isUpdateInformation"
                      >{{parseFloat(queryParams.proPrice).toFixed(2)}}</span>
                      <el-input-number
                        :controls="false"
                        :precision="2"
                        :min="0.01"
                        v-if="isUpdateInformation"
                        v-model="queryParams.proPrice"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-col :span="18">
                    <el-form-item label="型号别称：">
                      <span v-if="!isUpdateInformation">{{queryParams.proModelnick}}</span>
                      <el-input
                        style="margin-top:10px;"
                        type="textarea"
                        :rows="4"
                        v-if="isUpdateInformation"
                        v-model="queryParams.proModelnick"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="备注：">
                    <span v-if="!isUpdateInformation">{{queryParams.mark}}</span>
                    <el-input
                      style="margin-top:10px;"
                      v-if="isUpdateInformation"
                      v-model="queryParams.mark"
                      :rows="4"
                      type="textarea"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="产品类型：" prop="proType">
                    <span v-if="!isUpdateInformation">{{queryParams.proType===1?'标准产品':'组合产品'}}</span>
                    <el-radio-group v-if="isUpdateInformation" v-model="queryParams.proType">
                      <el-radio :label="1">标准产品</el-radio>
                      <el-radio :label="2">组合产品</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <div v-if="queryParams.proType === 2">
                <el-table
                  :data="tableData"
                  tooltip-effect="dark"
                  max-height="378"
                  :header-cell-style="tableHeader"
                  border
                >
                  <el-table-column prop="proModel" label="型号"></el-table-column>
                  <el-table-column prop="proOrdernum" label="订单货号"></el-table-column>
                  <el-table-column label="数量">
                    <template slot-scope="scope">
                      <span v-if="!isUpdateInformation">{{scope.row.needCount}}</span>
                      <el-input-number
                        :min="1"
                        :controls="false"
                        :precision="0"
                        v-if="isUpdateInformation"
                        v-model="scope.row.needCount"
                      ></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" v-if="isUpdateInformation">
                    <template slot-scope="scope">
                      <span class="approval" @click="onDelete(scope.row)">删除</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-row>
                  <el-col
                    :span="24"
                    style="text-align:right;margin-top:10px;"
                    v-if="isUpdateInformation"
                  >
                    <el-button type="primary" @click="addProductModel">添加子型号</el-button>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </el-form>
        <div class="add-basic-information">
          <div class="add-title">
            <span class="bold"></span>
            <span class="basic">参数</span>
            <div class="save" v-if="+$route.query.approvalState !==1">
              <el-button v-if="isUpdate" @click="onUpdateCancel">取消</el-button>
              <el-button type v-if="queryParams.pcId" @click="onAddParameter">添加参数</el-button>
              <el-button type v-if="!isUpdate" @click="onUpdate">修改</el-button>
              <el-button type="primary" v-if="isUpdate" @click="onSave">保存</el-button>
            </div>
            <el-row style="margin-top:20px !important;">
              <el-col :span="24" style="text-align:right"></el-col>
            </el-row>
          </div>
          <div class="add-content">
            <p v-if="parameterList.length<1">暂无参数项</p>
            <el-form
              v-else
              :class="!isUpdate ? 'details-line-height' : ''"
              :label-width="!isUpdate? '' : '125px'"
            >
              <el-row>
                <el-col :span="8" v-for="(item,index) in parameterList" :key="index">
                  <el-col :span="18">
                    <el-form-item :label="item.label+'：'">
                      <span
                        v-if="!isUpdate"
                      >{{item.productClassParamvalue?item.productClassParamvalue.pvValue:'--'}}</span>
                      <el-select
                        filterable
                        clearable
                        v-if="isUpdate"
                        v-model="item.productClassParamvalue"
                        value-key="id"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="(itemValue,index) in item.productClassParamvalueList"
                          :key="index"
                          :label="itemValue.pvValue"
                          :value="itemValue"
                        ></el-option>
                        <span class="add-params" @click="onParameterValue(item)">+ 添加参数值</span>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div v-if="+$route.query.approvalState === 0||+$route.query.approvalState ===1">
          <el-form
            :rules="rules"
            :model="paramsList"
            :label-width="+$route.query.approvalState ===1?'':'50px'"
            class="demo-form-inline"
          >
            <div class="add-basic-information">
              <div class="add-title">
                <span class="bold"></span>
                <span class="basic">审批</span>
              </div>
              <div class="add-content">
                <el-row>
                  <el-col :span="20" v-if="+$route.query.approvalState ===0">
                    <el-form-item label="审批结果：" label-width="70px">
                      <el-radio v-model="radio" :label="2">上线</el-radio>
                      <el-radio v-model="radio" :label="3">合并</el-radio>
                      <el-radio v-model="radio" :label="1">不通过</el-radio>
                    </el-form-item>
                  </el-col>
                  <el-col :span="20" v-if="+$route.query.approvalState ===1">
                    <el-form-item label="审批结果：" label-width="70px">{{"审批不通过"}}</el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="15" v-if="radio==1&&+$route.query.approvalState ===0">
                    <el-form-item label="备注：" prop="mark" label-width="65px">
                      <el-input
                        type="textarea"
                        :rows="4"
                        placeholder="请输入备注"
                        v-model="paramsList.mark"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="15" v-if="radio==2&&+$route.query.approvalState ===0">
                    <el-form-item label="备注：" label-width="45px">
                      <el-input
                        type="textarea"
                        :rows="4"
                        placeholder="请输入备注"
                        v-model="paramsList.mark"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="+$route.query.approvalState ===1">
                    <el-form-item label="备注：">{{queryParams.approvalMark}}</el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="radio===3&& +$route.query.approvalState ===0">
                  <el-col :span="20">
                    <el-form-item label="将临时产品并入：" label-width="120px" label-position="left">
                      <span class="approval">{{submitParams.productModel||''}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="radio===3&& +$route.query.approvalState ===0">
                  <el-col :span="5">
                    <el-form-item label="品类：">
                      <el-cascader v-model="searchReform.productClassId" :options="proClassList"></el-cascader>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="品牌：">
                      <el-select
                        v-model="searchReform.brandIds"
                        clearable
                        filterable
                        @change="brandIdChange(searchReform.brandIds)"
                      >
                        <el-option
                          v-for="item in brand"
                          :key="item.id"
                          :label="item.brandName"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="系列：">
                      <el-select
                        v-model="searchReform.seriesIds"
                        filterable
                        clearable
                        placeholder="全部"
                      >
                        <el-option
                          v-for="item in series"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label-width="10px">
                      <el-input placeholder="输入产品名称/型号/型号别称/订货号" v-model="searchReform.searchKey"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label-width="10px">
                      <el-button type="primary" @click="searchFor">搜索</el-button>
                      <el-button type @click="searchForReset">重置</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
                <div v-if="radio===3&& +$route.query.approvalState ===0">
                  <el-table
                    highlight-current-row
                    @current-change="handleCurrentChange"
                    :data="tableList"
                    height="378"
                    tooltip-effect="dark"
                    :header-cell-style="tableHeader"
                    border
                  >
                    <el-table-column show-overflow-tooltip prop="productClassName" label="品类"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="brandName" label="品牌"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="seriesName" label="系列"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="productName" label="产品名称"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="productModel" label="型号名称"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="productModelNick" label="型号别称"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="productOrderNum" label="订货号"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="productPrice" label="产品面价"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="productUnit" label="最小单位"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="productTerritory" label="属地"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="proModel" label="是否停产">
                      <template slot-scope="scope">
                        <span>{{scope.row.isStop === 1?'未停产':'已停产'}}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <!-------------- 分页 -------------->
                <div
                  class="pagination"
                  style="padding-top:20px;"
                  v-if="radio===3&& +$route.query.approvalState ===0"
                >
                  <pagination
                    :total="total"
                    :currentPage="page"
                    :pageSize="size"
                    @handleCurrentChange="handleCurrentPagination"
                    @handleSizeChange="handleSizePagination"
                  ></pagination>
                </div>
                <el-button
                  v-if="+$route.query.approvalState === 0"
                  type="primary"
                  @click="onSubmit"
                >提交</el-button>
              </div>
            </div>
          </el-form>
        </div>
        <!-------------- 操作日志 ------------>
        <load-operation-log ref="loadOperationLogRefs" :id="this.$route.query.id"></load-operation-log>
      </div>
    </div>
    <!-------------- 添加参数 -------------->
    <add-parameter-dialog @onRefresh="onRefreshParam" ref="addParameterDialogRefs"></add-parameter-dialog>
    <!-------------- 添加子型号 -------------->
    <add-model-dialog @onRefresh="getSelectList" ref="addModelDialogRefs"></add-model-dialog>
    <!-------------- 二次确认 -------------->
    <open-or-close-dialog
      ref="openOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close-dialog>
  </div>
</template>
<script>
import OpenOrClose from '@/components/OpenOrClose/index' // 二次确认

import addParameterDialog from '../dialog/addParameter'
import {
  productBaseQueryPageAll,
  queryProductParam,
  querySeriesByBrandId,
  queryProductByIdForEdit,
  productBaseUpdateProduct,
  deleteProductCombine,
  brandQueryPageAll,
  examineByProId,
  mergeProduct
} from '@/api/product/productManage'

import addModelDialog from '../dialog/addModel'
import pagination from '@/components/pagination'
import loadOperationLog from '@/components/OperationLog/loadOperationLog'
import { deepClone } from '@/util'

import { productAddOrEditRules } from '../utils/formRules'
export default {
  components: {
    'add-parameter-dialog': addParameterDialog,
    'add-model-dialog': addModelDialog,
    'load-operation-log': loadOperationLog,
    pagination: pagination,
    'open-or-close-dialog': OpenOrClose
  },
  watch: {
    radio: {
      handler (newVal) {
        this.submitParams = {}
      }
    }
  },
  data () {
    return {
      rules: {
        mark: { required: true, message: '请添加备注！', trigger: 'blur' }
      },
      paramsList: {
        proId: this.$route.query.id
      },
      title: '', // 标题
      content: '', // 内容
      total: 1,
      page: 1,
      size: 30,
      brand: [], // 品牌类型
      series: [], // 系列类型
      searchReform: {},
      tableList: [],
      mark: undefined,
      radio: 2, // 审核结果
      isUpdateInformation: false,
      proClassList: [], // 品类
      queryParams: {
        isStop: 1,
        proType: 1
      }, // 表单数据
      parameterList: [], // 参数列表
      brandList: [], // 品牌列表
      seriesList: [], // 系列列表
      unitList: [], // 最小单位
      tableData: [], // 表格数据
      paramsReform: {},
      // 产品属地
      productTerritoryList: [
        { productTerritory: '国产', title: '国产' },
        { productTerritory: '进口', title: '进口' },
        { productTerritory: '未知', title: '未知' }
      ],
      pitchOnPpId: [],
      queryParamsRules: productAddOrEditRules,
      isUpdate: false,
      submitParams: {}
    }
  },
  mounted () {
    this.query() // 初始化品牌列表选择器
    this.getProductClass() // 初始化产品分类信息级联数据
    this.queryParamsRules = {}
    this.getBrandForSelect() // 品牌初始化
    this.getQueryByClassCode() // 最小单位初始化
    this.getProductIdForEdit() // 获取编辑信息
    this.getList()
  },
  methods: {
    handleCurrentPagination (val) {
      this.page = val
      this.submitParams = {}
      this.getList()
    },
    handleSizePagination (val) {
      this.size = val
      this.submitParams = {}
      this.getList()
    },
    // 查询全部类型
    query () {
      // 品牌列表
      brandQueryPageAll()
        .then((res) => {
          if (res.data.code === 200) {
            this.brand = res.data.obj
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    searchForReset () {
      this.submitParams = {}
      this.searchReform = {}
      this.paramsReform = {}
      this.page = 1
      this.size = 30
      this.getList()
    },
    searchFor () {
      this.paramsReform = JSON.parse(JSON.stringify(this.searchReform))
      if (this.paramsReform.productClassId) {
        this.paramsReform.productClassId = this.paramsReform.productClassId[
          this.paramsReform.productClassId.length - 1
        ]
      }
      this.page = 1
      this.size = 30
      this.getList()
    },
    handleCurrentChange (val) {
      if (val !== null) {
        this.submitParams = val
      }
    },
    onSubmit () {
      if (this.radio === 1) {
        this.paramsList.approvalState = this.radio
        if (this.paramsList.mark === undefined || this.paramsList.mark === '') {
          this.$message.error('备注不能为空！')
        } else {
          this.title = '确定审批不通过'
          this.content = '确定将该产品设为不通过？'
          this.$refs.openOrCloseRefs.onInitial(this.radio)
        }
      } else if (this.radio === 2) {
        if (this.queryParams.proModel === null) {
          this.$message.error('型号不能为空！')
        } else {
          this.paramsList.approvalState = this.radio
          this.title = '上线'
          this.content = '确定上线该产品？'
          this.$refs.openOrCloseRefs.onInitial(this.radio)
        }
      } else {
        if (
          this.submitParams === {} ||
          this.submitParams === null ||
          this.submitParams.productModel === undefined
        ) {
          this.$message.error('请选中合并的产品！')
        } else {
          this.title = '合并产品确认'
          this.content =
            '确认将{' +
            this.queryParams.proModel +
            '}合并至{' +
            this.submitParams.productModel +
            '}'
          this.$refs.openOrCloseRefs.onInitial(this.radio)
        }
      }
    },
    onUpdataState (type) {
      if (type === 1 || type === 2) {
        examineByProId(this.paramsList)
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success('操作成功!')

              this.$router.push({
                name: 'productList',
                query: { goTo: 'temporaryProduct' }
              })
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        mergeProduct(this.$route.query.id, this.submitParams.id)
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success('合并成功!')
              this.$router.push({
                name: 'productList'
              })
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    getList () {
      const queryParams = JSON.parse(JSON.stringify(this.paramsReform))
      const params = {
        criteriaVoList: this.$queryParams(queryParams, 'moreSearch'),
        queryPageName: ''
      }
      productBaseQueryPageAll(1, this.page, this.size, params)
        .then((res) => {
          if (res.data.code === 200) {
            this.tableList = res.data.obj.records
            this.total = res.data.obj.total
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    brandIdChange (id) {
      delete this.searchReform.seriesId
      this.series = []
      this.getSeriseList(id)
    },
    // 根据产品id获取编辑信息
    getProductIdForEdit (type) {
      queryProductByIdForEdit(this.$route.query.id)
        .then((res) => {
          if (res.data.code === 200) {
            this.queryParams = res.data.obj.productBrandNameVo // 基本信息
            setTimeout(() => {
              const arrList = this.$idFindParent(
                res.data.obj.productBrandNameVo.pcId,
                this.proClassList
              )
              this.queryParams.pcId = arrList.map(String)
            }, 30)
            this.pitchOnPpId = res.data.obj.productParamContentList // 添加是选中的参数值
            this.getSeriseList(res.data.obj.productBrandNameVo.brandId) // 获取全部系数
            this.tableData = res.data.obj.productBomVoList // 组合产品
            this.getQueryProductParam(res.data.obj.productBrandNameVo.pcId) // 获取品类下面的参数清单
            if (type === 1) {
              this.isUpdateInformation = false
              this.isUpdate = false
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    onRefreshParam (id) {
      this.getProductIdForEdit() // 获取品类下面的参数清单
    },
    // 修改
    onUpdate () {
      this.isUpdate = true
    },
    onUpdateInformation () {
      this.queryParamsRules = productAddOrEditRules
      this.isUpdateInformation = true
    },
    onUpdateCancel () {
      this.$refs.queryParamsRefs.resetFields()
      this.getProductIdForEdit(1) // 获取编辑信息
      this.isUpdateInformation = false
      this.isUpdate = false
    },
    onSaveInformation () {
      this.$refs.queryParamsRefs.validate((valid) => {
        if (valid) {
          // 校验通过
          if (this.queryParams.pcId) {
            // 判断品类是否有值,有值的话再进行赋值
            this.queryParams.pcId = this.queryParams.pcId[
              this.queryParams.pcId.length - 1
            ] // 获取最后一级id
          }
          const list = []
          this.parameterList.forEach((item) => {
            if (item.productClassParamvalue) {
              const paramsList = {
                pcpId: item.id,
                pcpmId: item.productClassParamvalue.id,
                pcpmValue: item.productClassParamvalue.pvValue
              }
              list.push(paramsList)
            }
          })
          const params = {
            isFormalProduct: true,
            productBase: this.queryParams, // 基本信息
            productBomVoList: this.tableData, // 子型号
            productParamContentList: list // 参数
          }
          if (
            params.productBase.proOutunit === '套装出售' &&
            (params.productBase.proOutunitCount === null ||
              params.productBase.proOutunitCount === undefined ||
              params.productBase.proOutunitCount === '')
          ) {
            this.$message.error('数量不能为空!')
          } else if (
            params.productBase.proType === 2 &&
            params.productBomVoList.length === 0
          ) {
            this.$message.error('请至少添加一个子产品！')
          } else if (
            params.productBase.proOutunit === '套装出售' && (!params.productBase.proOutunitCount || !params.productBase.proOutunitUnit || params.productBase.proOutunitUnit === undefined)
          ) {
            this.$message.error('请选择套装出售数量并填写单位！')
          } else {
            params.amend = 1
            productBaseUpdateProduct(params)
              .then((res) => {
                // 编辑保存接口
                if (res.data.code === 200) {
                  this.$message.success('编辑成功!')
                  location.reload()

                  this.isUpdateInformation = false
                  this.isUpdate = false
                  this.getProductClass() // 品类初始化
                  this.getBrandForSelect() // 品牌初始化
                  this.getQueryByClassCode() // 最小单位初始化
                  this.getProductIdForEdit() // 获取编辑信息
                  this.$refs.loadOperationLogRefs.getAllOperationById(
                    'product-manager',
                    this.$route.query.id,
                    'again'
                  )
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              .catch((err) => {
                console.log(err)
              })
          }
        } else {
          console.log(111111)
          // 校验未通过
          this.$message.error('校验未通过')
          return false
        }
      })
    },
    // 保存
    onSave () {
      // 校验通过
      if (this.queryParams.pcId) {
        // 判断品类是否有值,有值的话再进行赋值
        this.queryParams.pcId = this.queryParams.pcId[
          this.queryParams.pcId.length - 1
        ] // 获取最后一级id
      }
      const list = []
      this.parameterList.forEach((item) => {
        if (item.productClassParamvalue) {
          const paramsList = {
            pcpId: item.id,
            pcpmId: item.productClassParamvalue.id,
            pcpmValue: item.productClassParamvalue.pvValue
          }
          list.push(paramsList)
        }
      })
      const params = {
        isFormalProduct: true,
        productBase: this.queryParams, // 基本信息
        productBomVoList: this.tableData, // 子型号
        productParamContentList: list, // 参数
        amend: 2
      }
      productBaseUpdateProduct(params)
        .then((res) => {
          // 编辑保存接口
          if (res.data.code === 200) {
            this.$message.success('编辑成功!')

            this.isUpdateInformation = false
            this.isUpdate = false
            this.getProductClass() // 品类初始化
            this.getBrandForSelect() // 品牌初始化
            this.getQueryByClassCode() // 最小单位初始化
            this.getProductIdForEdit() // 获取编辑信息
            this.$refs.loadOperationLogRefs.getAllOperationById(
              'product-manager',
              this.$route.query.id,
              'again'
            )
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
      // })
    },
    // 查看产品分类信息
    async getProductClass () {
      this.proClassList = await this.$queryAllProductClassForCascader()
    },
    // 选择品类获取的
    handleChange (value) {
      const pcId = value[value.length - 1] // 获取品类最后一级的id
      this.getQueryProductParam(pcId) // 获取品类下所有的参数清单
    },
    // 参数列表
    getQueryProductParam (id) {
      // this.getProductIdForEdit()
      queryProductParam(id)
        .then((res) => {
          if (res.data.code === 200) {
            const list = res.data.obj
            const arrList = []
            // 编辑时获取选中的品类id,调用参数列表接口获取全部参数,再把全部参数和编辑接口返回的选中参数进行对比
            list.forEach((item) => {
              if (item.productClassParamvalueList) {
                item.productClassParamvalueList.forEach((res) => {
                  // 全部参数
                  this.pitchOnPpId.forEach((element) => {
                    // 选中的参数
                    if (res.id === element.pcpmId) {
                      // 选中的参数值和全部参数值对比
                      item.productClassParamvalue = {
                        id: element.pcpmId,
                        ppId: element.pcpId,
                        pvValue: element.pcpmValue
                      }
                    }
                  })
                })
              }
              arrList.push(item)
            })
            this.parameterList = arrList
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 添加参数
    onAddParameter () {
      const pcId = this.queryParams.pcId[this.queryParams.pcId.length - 1]
      this.$refs.addParameterDialogRefs.onInitialize(1, pcId)
    },
    // 添加参数值
    onParameterValue (item) {
      const pcId = this.queryParams.pcId[this.queryParams.pcId.length - 1]
      this.$refs.addParameterDialogRefs.onInitialize(2, item, pcId)
    },
    // 获取所有品牌名称
    async getBrandForSelect () {
      this.brandList = await this.$queryAllBrandForSelect()
    },
    // 根据品牌id获取系列
    onChangeBrand (id) {
      this.queryParams.brandSid = ''
      this.getSeriseList(id)
    },
    // 获取系列列表
    getSeriseList (id) {
      if (id !== undefined) {
        querySeriesByBrandId(id)
          .then((res) => {
            if (res.data.code === 200) {
              if (res.data.code === 200) {
                this.seriesList = res.data.obj
                this.series = res.data.obj
              }
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        this.series = []
      }
    },
    // 根据多个分类类型显示属性内容
    async getQueryByClassCode () {
      const params = await this.$queryByClassCode()
      try {
        this.unitList = params.unitList
      } catch (e) {
        console.log(e)
      }
    },
    // 判断套装出售时是否有最小单位
    onChangeOutunit () {
      if (this.queryParams.proOutunit === '套装出售') {
        if (!this.queryParams.proUnit) {
          this.$message.error('请选择最小单位！')
        }
      }
    },
    // 显示添加型号弹框
    addProductModel () {
      this.$refs.addModelDialogRefs.onInitialize()
    },
    // 获取子型号
    getSelectList (list) {
      const dataList = deepClone(list)
      const tableDataList = deepClone(this.tableData)
      dataList.forEach((element, index) => {
        let isFalse = false
        tableDataList.forEach((ele) => {
          if (ele.proCbid === element.id) {
            isFalse = true
          }
        })
        if (!isFalse) {
          const params = {
            id: 0,
            needCount: 1,
            proBid: 0,
            proCbid: element.id,
            proModel: element.productModel,
            proName: element.productName,
            proOrdernum: element.productOrderNum,
            serial: index
          }
          this.tableData.push(params)
        }
      })
    },
    // 删除组合产品子型号
    onDelete (row) {
      if (row.id) {
        deleteProductCombine(row.proCbid, row.proBid)
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success('删除成功!')
              const index = this.tableData.indexOf(row)
              this.tableData.splice(index, 1)
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        const index = this.tableData.indexOf(row)
        this.tableData.splice(index, 1)
      }
    },
    // 设置头部颜色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
<style  lang="scss" scoped>
.add-content {
  span {
    display: block !important;
  }
}

.add-params {
  padding-left: 20px;
  font-size: 14px;
  color: #276cff;
  cursor: pointer;
  line-height: 30px;
  height: 30px;
}
</style>
